module.exports = __webpack_public_path__ + "static/media/pn.48bd62e4.svg";